import React from 'react';
import AdminNavigation from "./AdminNavigation";
import AdminStatistics from "../../Components/admin/AdminStatistics";
import AdminMessages from "../../Components/admin/AdminMessages";
import BlogList from "../../Components/admin/BlogList";

export default function AdminDashboard() {
    const [activeView, setActiveView] = React.useState("statistics");
    const renderComponent = () =>{
        switch (activeView) {
            case "statistics":
                return <AdminStatistics />
            case "messages":
                return <AdminMessages />
            case "bloglist":
                return <BlogList />
            default:
                return <div>I am default</div>

        }
    }
    return (
        <AdminNavigation setActiveView={setActiveView}>
            <h1 className="text-4xl font-bold mb-6">Dashboard</h1>
            <p className="text-neutral-600 mb-8">Welcome to your dashboard.</p>
            {renderComponent()}
        </AdminNavigation>
    );
}
